import { Selector } from '@ngxs/store';

import { CostCentreStateModel, CostCentreState } from './cost-centre.state';
import { CostCentre } from '../../core/models/cost-centre.model';

export class CostCentreGetterState {

  @Selector([CostCentreState])
  static getCostCentres(state: CostCentreStateModel): CostCentre[] {
    return state.ids.map(id => state.entities[id]);
  }
}
